import { configureStore } from '@reduxjs/toolkit'
import alertReducer from '@modules/app/reducers/alertReducer'
import appReducer from '@modules/app/reducers/appReducer'
import authReducer from '@modules/auth/reducers/authReducer'
import themeReducer from '@modules/theme/reducers/themeReducer'
import conviteReducer from '@modules/convite/reducers/conviteReducer'
import requestConviteReducer from '@modules/convite/reducers/requestConviteReducer'

const store = configureStore({
    reducer: {
        app: appReducer,

        auth: authReducer,
        
        alert: alertReducer,
        theme: themeReducer,

        convite: conviteReducer,
        requestConvite: requestConviteReducer,
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store